export const getDamageImagesCount = (images) =>
  images.filter((image) => image.imageType.toLowerCase() === "damage")
    ?.length || 0;

export const getBeautyImagesCount = (images) =>
  images.filter((image) => image.imageType.toLowerCase() !== "damage")
    ?.length || 0;
